import React from 'react';
import { Skeletons } from 'ui/components/skeleton';
import { currencyFormat } from 'utilities/common';

export const CardShipment = ({ isLoading, data }) => {
  return isLoading ? (
    <div className="card p-3 rounded-2 bg-white">
      <Skeletons height="460px" />
    </div>
  ) : (
    <div className="card p-3 rounded-2 bg-white">
      <h3 className="card-title dx-card-title border-bottom pb-2">
        Statistic Receivable
      </h3>
      <div className="d-flex justify-content-center px-3">
        <div className="col-6 col-md-3 rounded-2 border border-primary bg-primary-lt text-center p-3 m-1">
          <div className="fs-4 fw-semibold text-left text-primary">
            {currencyFormat(data?.subtotal_unpaid) || 0}
          </div>
          <div className="page-pretitle text-left text-primary">Belum Dibayar</div>
        </div>
        <div className="col-6 col-md-3 rounded-2 border border-danger bg-danger-lt text-center p-3 m-1">
          <div className="fs-4 fw-semibold text-left text-danger">
            {currencyFormat(data?.subtotal_overdue) || 0}
          </div>
          <div className="page-pretitle text-left text-danger">Jatuh Tempo</div>
        </div>
        <div className="col-6 col-md-3 rounded-2 border border-success bg-success-lt text-center p-3 m-1">
          <div className="fs-4 fw-semibold text-left text-success">
            {currencyFormat(data?.subtotal_paid) || 0}
          </div>
          <div className="page-pretitle text-left text-success">Pelunsan Diterima</div>
        </div>
        <div className="col-6 col-md-3 rounded-2 border border-secondary bg-secondary-lt text-center p-3 m-1">
          <div className="fs-4 fw-semibold text-left text-secondary">
            {currencyFormat(data?.subtotal_additional_charges) || 0}
          </div>
          <div className="page-pretitle text-left text-secondary">Return/Admin</div>
        </div>
      </div>
      <div className="mt-3 d-flex flex-row flex-wrap gap-2 justify-content-center">
        <div className="col-md-2 col-4 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {data?.total_new || 0}
            </div>
            <div className="page-pretitle text-secondary">Baru</div>
          </div>
        </div>
        <div className="col-md-2 col-4 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {data?.total_published || 0}
            </div>
            <div className="page-pretitle text-warning">Belum Dibayar</div>
          </div>
        </div>
        <div className="col-md-2 col-4 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {data?.total_overdue || 0}
            </div>
            <div className="page-pretitle text-danger">Overdue</div>
          </div>
        </div>
        <div className="col-md-2 col-4 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {data?.total_partial_paid || 0}
            </div>
            <div className="page-pretitle text-primary">Bayar Sebagian</div>
          </div>
        </div>
        <div className="col-md-2 col-4 mb-1 mb-md-0">
          <div className="rounded-2 border bg-light-lt text-center p-2">
            <div className="fs-5 fw-semibold text-left text-secondary">
              {data?.total_paid || 0}
            </div>
            <div className="page-pretitle text-success">Payment</div>
          </div>
        </div>
      </div>
    </div>
  );
};
